"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = exports.isDefined = exports.isFunction = exports.isPromise = exports.areArraysEqual = exports.isAbsoluteUrl = exports.EmptyRef = exports.safeEntries = exports.noop = exports.omitKey = exports.safeKeys = exports.maybeCall = exports.toGroupState = exports.toToggleState = void 0;
/** Adapts our state to what useToggleState returns in a stateless manner. */
function toToggleState(isSelected, onChange) {
    return {
        isSelected,
        setSelected: onChange,
        toggle: () => onChange(!isSelected),
    };
}
exports.toToggleState = toToggleState;
/** Adapts our state to what use*Group returns in a stateless manner. */
function toGroupState(values, onChange) {
    const addValue = (value) => onChange([...values, value]);
    const removeValue = (value) => onChange(values.filter((_value) => _value !== value));
    return {
        value: values,
        setValue: onChange,
        isSelected: (value) => values.includes(value),
        addValue,
        removeValue,
        toggleValue: (value) => (values.includes(value) ? addValue(value) : removeValue(value)),
        isDisabled: false,
        isReadOnly: false,
        // We do not use the validation state, as our Switch groups do not support error states. However, this field is required by the `CheckboxGroupState` so we need to include it.
        // If we ever update our SwitchGroup component to support error states, we'll need to update this.
        validationState: "valid",
    };
}
exports.toGroupState = toGroupState;
/**
 * Utility to maybe call a function if undefined with arguments
 *
 * @example
 *  maybeCall(onChange, true)
 *  maybeCall(onBlur)
 *  maybeCall(onSelect, { id: 1, value: "book 1"}, true)
 */
function maybeCall(callback, ...args) {
    return callback && callback(...args);
}
exports.maybeCall = maybeCall;
__exportStar(require("./useTestIds"), exports);
/** Casts `Object.keys` to "what it should be", as long as your instance doesn't have keys it shouldn't. */
function safeKeys(instance) {
    return Object.getOwnPropertyNames(instance);
}
exports.safeKeys = safeKeys;
// Returns object with specified key removed
const omitKey = (key, { [key]: _, ...obj }) => obj;
exports.omitKey = omitKey;
const noop = () => { };
exports.noop = noop;
function safeEntries(obj) {
    return Object.entries(obj);
}
exports.safeEntries = safeEntries;
class EmptyRef {
    get current() {
        throw new Error("BeamProvider is missing");
    }
    set current(value) {
        throw new Error("BeamProvider is missing");
    }
}
exports.EmptyRef = EmptyRef;
const isAbsoluteUrl = (url) => /^(http(s?)):\/\//i.test(url);
exports.isAbsoluteUrl = isAbsoluteUrl;
function areArraysEqual(a, b) {
    return a.length === b.length && a.every((val, idx) => val === b[idx]);
}
exports.areArraysEqual = areArraysEqual;
function isPromise(obj) {
    return typeof obj === "object" && "then" in obj && typeof obj.then === "function";
}
exports.isPromise = isPromise;
function isFunction(f) {
    return typeof f === "function";
}
exports.isFunction = isFunction;
function isDefined(param) {
    return param !== null && param !== undefined;
}
exports.isDefined = isDefined;
function pluralize(count, noun, pluralNoun) {
    if ((Array.isArray(count) ? count.length : count) === 1)
        return noun;
    return pluralNoun || `${noun}s`;
}
exports.pluralize = pluralize;
